export default __webpack_public_path__ + "static/media/Falcons.3418f25e.png";